import { GettersType } from "@/store/getters/type";
import { Project } from "@/interfaces/Project";
import { StoreType } from "@/interfaces/StoreType";

export default {
  [GettersType.GET_PROJECTS]: (state: StoreType): Array<Project> =>
    state.projects,
  [GettersType.GET_PROJECT]: (state: StoreType): Project => state.project,
};
